import { Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import React, { useState } from 'react';

const ObjetivosOrganismo = ({ data, setDatos }) => {
    const [newFactor, setNewFactor] = useState('');
    const [newOrganizacion, setNewOrganizacion] = useState('');
    const [newResultado, setNewResultado] = useState('');
    const [newPerspectiva, setNewPerspectiva] = useState('');

    const handleAddItem = (field, value) => {
        if (value) {
            setDatos({
                target: {
                    name: field,
                    value: [...data[field], value]
                }
            });
        }

    };

    const handleRemoveItem = (field, index) => {
        const updatedArray = data[field].filter((_, i) => i !== index);
        setDatos({
            target: {
                name: field,
                value: updatedArray
            }
        });
    };

    return (
        <div>
            <Grid container spacing={2}>
                {/* Sección de propósitos */}
                <Grid item xs={12}>
                    <Typography variant="h5">Objetivos del organismo</Typography>
                    <TextField onKeyDownCapture={(e) => e.key == 'Enter' ? setNewFactor(e.target.value) : ''}
                        multiline
                        minRows={3}
                        fullWidth
                        margin="normal"
                        label="Propósitos por los que surgió el organismo"
                        value={data.propositos}
                        onChange={(e) => setDatos({ target: { name: 'propositos', value: e.target.value } })}
                    />
                </Grid>

                {/* Sección de Factores */}
                <Grid item md={6} xs={12}>
                    <Typography variant="h6">Factores que han favorecido el desarrollo de la organización</Typography>
                    <Stack direction="row" spacing={2} marginBottom={2}>
                        <TextField
                            onKeyDownCapture={(e) => {
                                if (e.key == 'Enter') {
                                    handleAddItem('factores', newFactor)
                                    setNewFactor('');
                                }
                            }}
                            fullWidth
                            label="Agregar factor"
                            value={newFactor}
                            onChange={(e) => setNewFactor(e.target.value)}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => {
                                handleAddItem('factores', newFactor);
                                setNewFactor('');
                            }}
                        >
                            <Add />
                        </IconButton>
                    </Stack>
                    {data.factores.map((factor, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                            <Typography>{factor}</Typography>
                            <IconButton color="error" onClick={() => handleRemoveItem('factores', index)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Grid>

                {/* Sección de Organizaciones */}
                <Grid item md={6} xs={12}>
                    <Typography variant="h6">Organizaciones o programas que han contribuido</Typography>
                    <Stack direction="row" spacing={2} marginBottom={2}>
                        <TextField
                            onKeyDownCapture={(e) => {
                                if (e.key == 'Enter') {
                                    handleAddItem('organizaciones', newOrganizacion)
                                    setNewOrganizacion('');
                                }
                            }} fullWidth
                            label="Agregar organización"
                            value={newOrganizacion}
                            onChange={(e) => setNewOrganizacion(e.target.value)}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => {
                                handleAddItem('organizaciones', newOrganizacion);
                                setNewOrganizacion('');
                            }}
                        >
                            <Add />
                        </IconButton>
                    </Stack>
                    {data.organizaciones.map((org, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                            <Typography>{org}</Typography>
                            <IconButton color="error" onClick={() => handleRemoveItem('organizaciones', index)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Grid>

                {/* Sección de Resultados */}
                <Grid item md={6} xs={12}>
                    <Typography variant="h6">Resultados socioeconómicos y ambientales</Typography>
                    <Stack direction="row" spacing={2} marginBottom={2}>
                        <TextField
                            onKeyDownCapture={(e) => {
                                if (e.key == 'Enter') {
                                    handleAddItem('resultados', newResultado)
                                    setNewResultado('');
                                }
                            }}
                            fullWidth
                            label="Agregar resultado"
                            value={newResultado}
                            onChange={(e) => setNewResultado(e.target.value)}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => {
                                handleAddItem('resultados', newResultado);
                                setNewResultado('');
                            }}
                        >
                            <Add />
                        </IconButton>
                    </Stack>
                    {data.resultados.map((resultado, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                            <Typography>{resultado}</Typography>
                            <IconButton color="error" onClick={() => handleRemoveItem('resultados', index)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Grid>

                {/* Sección de Perspectivas */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h6">Perspectivas y beneficios posibles</Typography>
                    <Stack direction="row" spacing={2} marginBottom={2}>
                        <TextField
                            onKeyDownCapture={(e) => {
                                if (e.key == 'Enter') {
                                    handleAddItem('perspectivas', newPerspectiva)
                                    setNewPerspectiva('');
                                }
                            }}
                            fullWidth
                            label="Agregar perspectiva"
                            value={newPerspectiva}
                            onChange={(e) => setNewPerspectiva(e.target.value)}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => {
                                handleAddItem('perspectivas', newPerspectiva);
                                setNewPerspectiva('');
                            }}
                        >
                            <Add />
                        </IconButton>
                    </Stack>
                    {data.perspectivas.map((perspectiva, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                            <Typography>{perspectiva}</Typography>
                            <IconButton color="error" onClick={() => handleRemoveItem('perspectivas', index)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
};

export default ObjetivosOrganismo;
